import Tag from "./main";
export default Tag;
